import { Component, OnInit } from '@angular/core';
import { TH } from 'src/app/constants/constants';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'));
  constructor() { }
  ngOnInit() {
    if (this.language == null) {
      this.language = JSON.parse(JSON.stringify(TH));
    }
  }

}
